<template>
  <div
    v-if="author || (authordate && isDate(authordate))"
    class="byline-component "
  >
    <span
      v-if="author"
      v-edit="'Author'"
      class="byline-component__author"
      :class="{'byline-component__author--only': !(authordate && isDate(authordate))}"
    > {{ author }}
    </span>
    <time
      v-if="authordate && isDate(authordate)"
      v-edit="'authordate'"
      class="byline-component__date-wrapper"
      :class="{'byline-component__date-wrapper--only': !author}"
    >
      {{ dateFormat(authordate) }}
    </time>
  </div>
</template>
<script>
import format from 'dateformat'

export default {
  name: "BylineComponent",
  props: {
    author: {
      type: String,
      default: ""
    },
    authordate: {
      type: String,
      default: ""
    }
  },
  data () {
    return {}
  },
  methods: {
    isDate (authordate) {
      try {
         return format(new Date(authordate), "yyyy") > 1
      } catch (error) {
        console.error(error)
        return null
      }
    },
    dateFormat (authordate) {
      return format(new Date(authordate), "yyyy-mm-dd")
    }
  }
}
</script>

<style lang="scss">
.byline-component {
  color: $color-grey-dark;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @include media-breakpoint-up(md) {
    display: inline-flex;
    justify-content: flex-start;
  }

  @include font(text, 2, "light");

  @include media-breakpoint-up(md) {
    margin-right: 0.5rem;
    margin-bottom: 0;
  }

  &__author {
    font-style: normal;
    padding-right: 0.5rem;
    margin-right: 0.5rem;
    position: relative;
    text-align: right;

    &--only {
      padding: 0;
      margin: 0 1rem;

      @include media-breakpoint-up(md) {
        margin: 0;
      }

      &::after {
        display: none;
      }
    }

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      border-right: 0.0625rem solid $color-grey-special;
    }
  }

  &__date-wrapper {
    padding-right: 0.5625rem;
    display: inline-block;
    position: relative;
    white-space: nowrap;

    &--only {
      padding: 0;
      margin: 0 1rem;

      @include media-breakpoint-up(md) {
        margin: 0;
      }
    }
  }
}

</style>
